/**
 * 当前文件请求接口头地址
 */
import http from 'lib//http';
export var urlgetSchoolImportActivityList = '/api/XOrg/Prepare/getSchoolImportActivityList';
export var urlimportActivity = '/api/XOrg/Prepare/importActivity';
export var urlgetActivityInfo = '/api/XOrg/Prepare/getActivityInfo';
;
export function getSchoolImportActivityList(courseId, activityType, pageSize, page) {
  return http.post(urlgetSchoolImportActivityList, {
    courseId: courseId,
    activityType: activityType,
    pageSize: pageSize,
    page: page
  });
}
;
export function importActivity(ids, courseId) {
  return http.post(urlimportActivity, {
    ids: ids,
    courseId: courseId
  });
}
export function getActivityInfo(id) {
  return http.post(urlgetActivityInfo, {
    id: id
  });
}